export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export const isDecimal = function (value) {
  return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value)
}

export const unmask = function (value, ds = ',') {
  value = (value || '').toString()
  return value.replace(/(?!-)\D/g, '')
}

export const mask = function (value, dp = -1, editing = false, ds = ',', gs = '.') {
  value = (value || '').toString()
  return value.replace(/(?!-)\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const setCookie = function (name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export const getCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
export const eraseCookie = function (name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const obj2FormData = (obj, formData = new FormData()) => {
  const createFormData = function (obj, subKeyStr = '') {
    for (let i in obj) {
      let value = obj[i]
      let subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i

      if (typeof (value) !== 'object') {

        formData.append(subKeyStrTrans, value)

      } else if (typeof (value) === 'object') {

        createFormData(value, subKeyStrTrans)
      }
    }
  }
  createFormData(obj)
  return formData
}